/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SectionBreakIcon = /*#__PURE__*/ createSvgIcon(
  'SectionBreakIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path d="M0 10h20" stroke="currentColor" strokeMiterlimit={10} />
        </>
      ),
    },
  },
  false
);

export default SectionBreakIcon;
